import _ from 'lodash';
import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { selectVirtualEventSummary } from '../../features/summary/summary.selectors';
import { selectVirtualEventSelectedCampaign } from '../../features/data/data.selectors';

@Component({
  selector: 'app-currently-live-campaign',
  templateUrl: './currently-live-campaign.component.html',
  styleUrls: ['./currently-live-campaign.component.scss']
})
export class CurrentlyLiveCampaignComponent implements OnInit {
  public summary$: any = this.store.pipe(select(selectVirtualEventSummary));
  public campaign$: any = this.store.pipe(select(selectVirtualEventSelectedCampaign));

  constructor(
    private store: Store<any>,
  ) { }

  ngOnInit(): void {
  }

  isNotEmpty(campaign) {
    return !_.isEmpty(campaign);
  }

  calculateRaisedValue(summary, selectedCampaign): number {
    const list = _.get(summary, 'byCampaign', []);
    const filteredList = _.filter(list, campaign => {
      return _.isEqual(campaign.campaignData.id, selectedCampaign.id);
    });
    return _.sumBy(filteredList, campaign => {
      return campaign.pendingAmount + campaign.donatedAmount;
    });
  }

}
